var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.callText)?_c('div',{staticClass:"call-balloon"},[_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.callText)+" ")]),_c('PhoneIcon',{staticClass:"speech-bubble"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }